module.exports = __webpack_public_path__ + "img/add_insert_link_af.65211e16.svg";